import React from 'react';

import {CloseIcon, IconProps} from '../icons';
import {Button, ButtonProps} from './Button';

interface Props extends ButtonProps, Pick<IconProps, 'color'> {}

export const CloseButton: React.FC<Props> = ({color, ...props}) => (
  <Button variant="transparent" {...props}>
    <CloseIcon {...{color}} strokeWidth={1.5} />
  </Button>
);
